module.exports = __webpack_public_path__ + "static/media/3_RoomControls_ReadingLight_HL.0e7b9a86.png";